import axios from '../axios'

// 获取七牛上传的token
export const getUpToken = data => {
  return axios({
    url: '/match/file/getUpToken',
    method: 'get'
  })
}

// 按人收费，查询费用
export const people = data => {
  return axios({
    url: '/matchJoin/matchCharge/people/' + data.matchId,
    method: 'get'
  })
}

/**
 * 添加机构
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const addAgency = data => {
  return axios({
    url: '/matchJoin/matchJoin/agency/addAgency',
    method: 'POST',
    data
  })
}

/**
 * 获取机构列表
 * @returns {Promise | Promise<unknown>}
 */
export const agencyList = () => {
  return axios({
    url: '/matchJoin/matchJoin/agency/agencyList',
    method: 'GET'
  })
}

/**
 * 添加教练
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const addStaff = data => {
  return axios({
    url: '/matchJoin/matchJoin/agencyStaff/addStaff',
    method: 'POST',
    data
  })
}

/**
 * 通过队伍查询该队伍的带队教练信息{matchId}/{teamId}
 * @returns {Promise | Promise<unknown>}
 */
export const queryLeadersByTeam = (matchId, teamId) => {
  return axios({
    url: '/matchJoin/matchJoin/agencyStaff/queryLeadersByTeam/' + matchId + '/' + teamId,
    method: 'GET'
  })
}

/**
 * 大球通过队伍查询该队伍的带队教练信息{matchId}/{teamId}
 * @returns {Promise | Promise<unknown>}
 */
export const queryLeadersByTeamBig = (matchId, teamId, combatDetailId) => {
  return axios({
    url: '/matchJoin/matchJoin/agencyStaff/queryLeadersByTeamBig/' + matchId + '/' + teamId + '/' + combatDetailId,
    method: 'GET'
  })
}

/**
 * 查询机构下的教练、领队等信息
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const queryAgencyStaff = (agencyId) => {
  return axios({
    url: '/matchJoin/matchJoin/agencyStaff/queryAgencyStaff/' + agencyId,
    method: 'GET'
  })
}

/**
 * 修改新提交的教练或领队
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const LeaderStaffAddOrUpdate = data => {
  return axios({
    url: '/match/matchLeaderStaffServer/addOrUpdate/' + data.staffIds + '/' + data.matchId + '/' + data.teamId,
    method: 'POST'
  })
}

/**
 * 修改新提交的教练或领队
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const LeaderStaffNewAddOrUpdate = data => {
  return axios({
    url: '/match/matchLeaderStaffServer/newAddOrUpdate/' + data.staffId + '/' + data.matchId + '/' + data.teamId,
    method: 'POST'
  })
}

/**
 * 查询机构团队
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const getMatchTeam = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchTeam/get/' + data.agencyId + '/' + data.programId,
    method: 'GET'
  })
}

/**
 * 报名查询该机构要绑定的邀请码
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const onlineFindCode = data => {
  return axios({
    url: '/match/cooperative/onlineFindCode/' + data.agencyId + '/' + data.matchId,
    method: 'GET'
  })
}

/**
 * 报名查询该机构要绑定的邀请码
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const inviteFindCode = data => {
  return axios({
    url: '/match/invite/findCode/' + data.agencyId + '/' + data.matchId,
    method: 'GET'
  })
}

/**
 * 报名查询该机构要绑定的邀请码
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const onlineBindAgencyCode = data => {
  return axios({
    url: '/match/cooperative/onlineBindAgencyCode/' + data.agencyId + '/' + data.matchId + '/' + data.code,
    method: 'GET'
  })
}

/**
 * 报名查询该机构要绑定的邀请码
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const inviteBindAgencyCode = data => {
  return axios({
    url: '/match/invite/bindAgencyCode/' + data.agencyId + '/' + data.matchId + '/' + data.code,
    method: 'GET'
  })
}

/**
 * 查询该机构有哪些需要小队的项目
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const getProgram = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchTeam/getProgram/' + data.agencyId,
    method: 'GET'
  })
}

/**
 * 删除队伍
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const delMatchTeam = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchTeam/del/' + data.id,
    method: 'DELETE'
  })
}

/**
 * 添加队伍
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const addMatchTeam = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchTeam/add',
    method: 'POST',
    data
  })
}

/**
 * 修改队伍
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const updateMatchTeam = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchTeam/update',
    method: 'PUT',
    data
  })
}
/**
* 添加小球类球员信息
* @param data
* @returns {Promise | Promise<unknown>}
*/
export const addSmallBallPlayer = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/addSmallBallPlayer',
    method: 'POST',
    data
  })
}

/**
 * 批量导入小球类球员
 * @param agencyId     参赛机构id
 * @param organisersId 赛事主办方id
 * @param formData
 */
export const importSmallballPlayer = (agencyId, organisersId, matchId, formData) => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/importSmallballPlayer/' + agencyId + '/' + organisersId + '/' + matchId,
    data: formData,
    method: 'POST',
    hdaders: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 导入大球类球员
 * @param agencyId
 * @param teamId
 * @param matchId
 * @param organisersId
 */
export const importBigballPlayer = (agencyId, organisersId, teamId, matchId, formData) => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/importBigballPlayer/' + agencyId + '/' + organisersId + '/' + teamId + '/' + matchId,
    data: formData,
    method: 'POST',
    hdaders: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 绑定球员头像
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const addPlayerHead = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/addPlayerHead',
    method: 'POST',
    data
  })
}

/**
 * 报名搜索运动员
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryPlayersByKeyWords = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/queryPlayersByKeyWords/' + data.agencyId + '/' + data.accountId + '/' + data.keyWords,
    method: 'get'
  })
}

/**
 * 上传附件查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findAdditional = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findAdditional/' + data.matchId,
    method: 'get'
  })
}

/**
 * 上传附件查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findEnclosureTeam = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findEnclosureTeam/' + data.matchId,
    method: 'get'
  })
}
/**
 * 上传附件查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findCardAdditional = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findCardAdditional/' + data.matchId + '/' + data.cardId,
    method: 'get'
  })
}

/**
 * 上传附件查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findEnclosureTeamList = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findEnclosureTeamList/' + data.matchId + '/' + data.teamId,
    method: 'get'
  })
}

/**
 * 上传视频查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findCardVideo = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findCardVideo/' + data.matchId + '/' + data.cardId,
    method: 'get'
  })
}

/**
 * 上传信息查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findCardInformation = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findCardInformation/' + data.matchId + '/' + data.cardId,
    method: 'get'
  })
}

/**
 * 上传信息查询配置
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findInformationList = data => {
  return axios({
    url: '/match/combatInformation/list/' + data.matchId,
    method: 'get'
  })
}

/**
 * 上传信息查询配置
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findNoticeGetOne = data => {
  return axios({
    url: '/match/notice/getNotice/' + data.matchId + '/' + data.type,
    method: 'get'
  })
}

/**
 * 上传视频审核不通过的查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryJoinVideoNoExamine = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/queryJoinVideoNoExamine/' + data.matchId + '/' + data.agencyId + '/' + data.customerId,
    method: 'get'
  })
}

// 查询匹配的报名项目
export const findCombatDetailByCard = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findCombatDetailByCard/' + data.matchId + '/' + data.birthday + '/' + data.sex + '/' + data.cardId + '/' + data.agencyId,
    method: 'get'
  })
}

/**
 * 重竞技报名提交
 * @param {*} data
 */
export const joinNormal = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/joinNormal',
    method: 'post',
    data
  })
}

/**
 * 小球类赛事报名1.1
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const joinSmallball11 = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/v1.1/joinSmallball',
    method: 'POST',
    data
  })
}

/**
 * 查询小球类的报名列表1.1
 * @param matchId
 * @param agencyId
 * @param teamId
 * @returns {Promise | Promise<unknown>}
 */
export const querySmallBallPayList11 = (matchId, agencyId, teamId) => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/v1.1/querySmallBallPayList/' + matchId + '/' + agencyId + '/' + teamId,
    method: 'GET'
  })
}

/**
 * 删除小球参赛队员
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const delSmallballJoinPlayer = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/delSmallballJoinPlayer/' + data.matchId + '/' + data.agencyId + '/' + data.combatId + '/' + data.combatDetailId + '/' + data.cardId + '/' + data.teamId + '/' + data.teamNumber,
    method: 'DELETE'
  })
}

/**
 * 查询参赛信息 {matchId}/{agencyId}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryJoinData = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/queryJoinData/' + data.matchId + '/' + data.agencyId,
    method: 'get'
  })
}

/**
 *  下载保险凭证
 * @param {*} data
 */
export const exportInsurancePdf = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/exportInsurancePdf/' + data.matchId + '/' + data.agencyId,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 *  下载个人报名保险凭证
 * @param {*} data
 */
export const exportPersonalInsurancePdf = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/exportPersonalInsurancePdf/' + data.matchId + '/' + data.customerId,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 *  打印报名列表
 * @param {*} data
 */
export const exportSignDataExcel = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/exportSignDataExcel/' + data.matchId + '/' + data.agencyId + '/' + data.type,
    method: 'get',
    responseType: 'blob'
  })
}


/**
 *  打印报名列表
 * @param {*} data
 */
export const exportSignDataExcelV1 = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/exportSignDataExcelV1/' + data.matchId + '/' + data.agencyId + '/' + data.type,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 *  打印报名列表
 * @param {*} data
 */
export const exportSignDataExcelV2 = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/exportSignDataExcelV2/' + data.matchId + '/' + data.agencyId,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 *  打印报名列表
 * @param {*} data
 */
export const exportSignDataPdfV2 = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/exportSignDataPdfV2/' + data.matchId + '/' + data.agencyId,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 *  打印个人报名列表
 * @param {*} data
 */
export const exportPersonalSignDataExcel = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/exportPersonalSignDataExcel/' + data.matchId + '/' + data.customerId,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 查询参赛信息 {matchId}/{agencyId}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const querySmallBallPayList = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/querySmallBallPayList/' + data.matchId + '/' + data.agencyId,
    method: 'get'
  })
}

/**
 * 查询个人报名的报名列表
 * @param matchId
 * @param agencyId
 * @param teamId
 * @returns {Promise | Promise<unknown>}
 */
export const queryPersonalPlayList = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/queryPersonalPlayList/' + data.matchId + '/' + data.customerId,
    method: 'GET'
  })
}

/**
 * 短兵查询团体项目的公斤级
 * @param matchId
 * @param agencyId
 * @param teamId
 * @returns {Promise | Promise<unknown>}
 */
export const findAppointWeight = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinWeight/findAppointWeight/' + data.matchId + '/' + data.agencyId + '/' + data.teamId,
    method: 'GET'
  })
}

/**
 * 短兵修改团体项目的公斤级
 * @param {*} data
 */
export const joinAppointWeight = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinWeight/joinAppointWeight',
    method: 'post',
    data
  })
}

/**
 * 查询参赛带队人员信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryJoinedLeaders = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/queryJoinedLeaders/' + data.matchId + '/' + data.agencyId + '/' + data.teamId,
    method: 'get'
  })
}

/**
 * 删除参赛队员 {matchId}/{agencyId}/{combatId}/{combatDetailId}/{cardId}/{teamId}/{teamNumber}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const delJoinPlayer = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/delJoinPlayer/' + data.matchId + '/' + data.agencyId + '/' + data.combatId + '/' + data.combatDetailId + '/' + data.cardId + '/' + data.teamId + '/' + data.teamNumber,
    method: 'delete'
  })
}

/**
 * 删除参赛队员全部信息 {matchId}/{agencyId}/{cardId}/{teamId}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const delJoinPlayerAll = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/delJoinPlayerAll/' + data.matchId + '/' + data.agencyId + '/' + data.cardId + '/' + data.teamId,
    method: 'delete'
  })
}

/**
 * 删除参赛队伍 {matchId}/{agencyId}/{combatId}/{combatDetailId}/{teamId}/{teamNumber}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const delJoinTeam = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/delJoinTeam/' + data.matchId + '/' + data.agencyId + '/' + data.combatId + '/' + data.combatDetailId + '/' + data.teamId + '/' + data.teamNumber,
    method: 'delete'
  })
}

/**
 * 查询参赛信息 {matchId}/{agencyId}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findSinglePlayer = data => {
  return axios({
    url: '/match/player/findSinglePlayer/' + data.agencyId + '/' + data.cardId,
    method: 'get'
  })
}

/**
 * 创建保险费订单  PS: 请前端在传递购买保险的人员id时过滤掉已经付费成功的数据
 * @param {*} data
 */
export const createInsuranceOrder = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/createInsuranceOrder',
    method: 'post',
    data
  })
}

/**
 * 根据选择的保险类型创建保险订单
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const createInsuranceOrderByType = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/createInsuranceOrderByType',
    method: 'post',
    data
  })
}

/**
 * 创建报名订单  PS：请前端在传递报名的运动员数据时过滤掉已经付费成功的数据, 如果计算出本次应支付的金额为0则默认返回报名支
 * @param {*} data
 */
export const createSignUpOrder = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/createSignUpOrder',
    method: 'post',
    data
  })
}

/**
 * 添加监护人手机号
 * @param {*} data
 */
export const bindPlayerGuardianPhone = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/bindPlayerGuardianPhone',
    method: 'post',
    data
  })
}

/**
 * 查询订单支付状态 {orderNumber}/{orderType}
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryOrderStatus = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/queryOrderStatus/' + data.orderNumber + '/' + data.orderType,
    method: 'get'
  })
}

/**
 * 查询打球类项目列表
 * @param matchId
 * @returns {Promise | Promise<unknown>}
 */
export const findBigballCombatDetail = matchId => {
  return axios({
    url: '/matchJoin/matchJoin/matchCombat/findBigballCombatDetail/' + matchId,
    method: 'get'
  })
}

/**
 * 添加大球类球员
 * @param data
 */
export const addBigballPlayer = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/addBasketBallPlayer',
    method: 'POST',
    data
  })
}

/**
 * queryPlayerByTeam
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryPlayerByTeam = data => {
  return axios({
    url: '/matchJoin/matchJoin/matchPlayer/queryPlayerByTeam/' + data.matchId + '/' + data.combatDetailId + '/' + data.agencyId + '/' + data.teamId + '/' + data.programId,
    method: 'GET'
  })
}

/**
 * delPlayerLocation
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const delPlayerLocation = data => {
  return axios({
    url: '/matchJoin/playerLocation/delPlayerLocation/' + data.matchId + '/' + data.cardId + '/' + data.agencyId + '/' + data.teamId + '/' + data.programId,
    method: 'DELETE'
  })
}

/**
 * 修改位置或球衣号
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const updateLocation = data => {
  return axios({
    url: '/matchJoin/playerLocation/updateLocation',
    method: 'PUT',
    data
  })
}

/**
 * 获取球衣颜色
 * @param agencyId
 * @param teamId
 * @returns {Promise | Promise<unknown>}
 */
export const findJerseyColor = (agencyId, teamId) => {
  return axios({
    url: '/matchJoin/matchJoin/jerseyColor/findJerseyColor/' + agencyId + '/' + teamId,
    method: 'GET'
  })
}

/**
 * 篮球赛事报名
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const joinBaskeyball = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/joinBaskeyball',
    method: 'POST',
    data
  })
}

/**
 * 足球赛事报名
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const joinFootball = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/joinFootball',
    method: 'POST',
    data
  })
}

/**
 * 查询保险费购买信息
 * @param matchId
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const queryInsuranceData = (matchId, agencyId) => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/queryInsuranceData/' + matchId + '/' + agencyId,
    method: 'GET'
  })
}

/**
 * 查询大球类报名费购买信息
 * @param matchId
 * @param agencyId
 * @param programId
 * @returns {Promise | Promise<unknown>}
 */
export const queryBigballSingupData = (matchId, agencyId, programId) => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/queryBigballSingupData/' + matchId + '/' + agencyId + '/' + programId,
    method: 'GET'
  })
}

/**
 * 获取报名费用收费配置信息
 * @param matchId
 * @returns {Promise | Promise<unknown>}
 */
export const queryPayModelData = matchId => {
  return axios({
    url: '/matchJoin/matchJoin/joinPay/queryPayModelData/' + matchId,
    method: 'GET'
  })
}

/**
 * 小球报名检查附件
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const checkEnclosureSmallball = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/checkEnclosureSmallball',
    method: 'POST',
    data
  })
}

/**
 * 大球报名检查附件
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const checkEnclosureBigball = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/checkEnclosureBigball',
    method: 'POST',
    data
  })
}

/**
 * 批量保存附件
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const saveEnclosureBatch = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinData/saveEnclosureBatch',
    method: 'POST',
    data
  })
}

/**
 * 查询赛事保险险种
 * @param matchId
 * @returns {Promise | Promise<unknown>}
 */
export const findMatchInsurance = matchId => {
  return axios({
    url: '/match/basic/findMatchInsurance/' + matchId,
    method: 'GET'
  })
}

/**
 * 查询该项目需要上传的视频
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findVideo = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinVideo/findVideo/' + data.agencyId + '/' + data.teamId + '/' + data.combatId + '/' + data.combatDetailId + '/' + data.teamNumber + '/' + data.cardId,
    method: 'GET'
  })
}

/**
 * 线上赛事配置查询
 * @param {*} data
 */
export const empowerOnlineFindSetting = data => {
  return axios({
    url: '/match/empower/findSetting/' + data.matchId,
    method: 'get'
  })
}

/**
 * 查询代表团授权机构
 * @param {*} data
 */
export const findEmpowerAgency = data => {
  return axios({
    url: '/match/delegation/findEmpowerAgency/' + data.matchId,
    method: 'get'
  })
}

/**
 * 查询指定公斤级
 * @param {*} data
 */
export const findSportsWeight = data => {
  return axios({
    url: '/matchJoin/matchJoin/joinWeight/findSportsWeight/' + data.matchId + '/' + data.agencyId + '/' + data.teamId + '/' + data.cardId,
    method: 'get'
  })
}

/**
 * 查询指定公斤级
 * @param {*} data
 */
export const findThreeJoinWeight = data => {
  return axios({
    url: '/matchJoin/matchJoin/join/findThreeJoinWeight/' + data.matchId + '/' + data.agencyId,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/comm/http/modules/join.js